require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./article-webmd-diagnosis.json") })
        }
      }, "path---article-webmd-diagnosis");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---article-webmd-diagnosis!./.cache/json/article-webmd-diagnosis.json
// module id = 370
// module chunks = 231608221292675